/* global $ */

import { Controller } from 'stimulus';

class SelectBox extends Controller {
  onWindowClick(e) {
    const openCollapseBox = this.element.querySelector('.collapse.show');

    const parent = e.target.closest('[data-controller="select-box"]');

    if (!parent && openCollapseBox) {
      $(openCollapseBox).collapse('hide');
    }
  }
}

export default SelectBox;
